export const initial = {
  list: [],
  selected: '',
  keyword: ''
};

export default (state = initial, action = {}) => {
  switch (action.type) {
    case 'PLAYERS_SET':
      return { ...state, list: action.payload };
    case 'PLAYERS_KEYWORD_SET':
      return { ...state, keyword: action.payload };
    case 'PLAYERS_SELECTED_SET':
      return { ...state, keyword: initial.keyword, selected: action.payload };
    default:
      return state;
  }
};
